<script lang="ts" setup>
import type { IJob } from '@/types/LP/job'
import { register } from 'swiper/element/bundle'

const { $api } = useNuxtApp()
const { locale, t } = useI18n()

const sectionData = {
    "section_title": {
        "en": "Recent Jobs",
        "id": "Lowongan Terbaru"
    }
}

const content = ref({
    content: [
        {
            image: { url: '' },
            title: { en: '', id: '' },
            description: { en: '', id: '' }
        }
    ],
    description: '',
    title: ''
})
const isLoading = ref(false)
const jobs = ref<IJob[]>([])

const isSwiperBeginning = ref(false)
const isSwiperEnd = ref(false)

const onProgress = (event:any) => {
    const [swiper] = event.detail
    isSwiperBeginning.value = swiper.isBeginning
    isSwiperEnd.value = swiper.isEnd
}


const swiperRef = ref(null)

onMounted(() => {
    nextTick(async () => {
        isLoading.value = true
        const { data: contentData } =
        await $api.landingPage.getLpRecentJobsTitle()
        content.value = contentData.value.data

        const { data: trendingJobs } = await $api.landingPage.getRecentJobs()
        jobs.value = trendingJobs.value.data
        
        isLoading.value = false
        register() // Register swiper custom elements

        // Crucial: Wait for the next DOM update after isLoading is false
        setTimeout(() => {
            const swiperEl = document.querySelector('swiper-container')
            const swiperParams = {
                navigation: {
                    prevEl: '.recent-job__btn-previous',
                    nextEl: '.recent-job__btn-next'
                },
                injectStyles: [
                  // This ensures the custom buttons work within the Shadow DOM if needed
                ],
            }
            
            // Assign parameters and initialize
            if (swiperEl) {
                Object.assign(swiperEl, swiperParams)
                swiperEl.initialize()
            }
        }, 100)
    })
})
</script>

<template>
    <section class="recent-job">
        <VContainer>
            <div class="recent-job__inner">
                <div class="recent-job__header">
                    <SectionTitle 
                        align="left"
                        size="md"
                        :title="sectionData.section_title[locale as 'en' | 'id']"
                    />
                    <div class="d-flex justify-space-between mb-5">
                       
                            <VBtn
                                class="recent-job__btn-previous me-3"
                                icon="ri-arrow-left-s-line"
                                color="error"
                                :aria-label="t('previous_slide')"
                                :disabled="isSwiperBeginning"
                            ></VBtn>
                            <VBtn
                                class="recent-job__btn-next"
                                icon="ri-arrow-right-s-line"
                                color="error"
                                :aria-label="t('next_slide')"
                                :disabled="isSwiperEnd"
                            ></VBtn>
                        
                    </div>
                </div>

                <div class="recent-job__content">
                        <VRow v-if="isLoading">
                            <VCol v-for="index in 3" :key="index" cols="12" md="4">
                                <CardJobSkeleton />
                            </VCol>
                        </VRow>
                        
                        <swiper-container
                            v-else
                            ref="swiperRef"
                            init="false"
                            a11y="false"
                            slides-per-view="1"
                            space-between="0"
                            :breakpoints="{
                                760: {
                                    slidesPerView: 2,
                                    spaceBetween: 15
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 15
                                }
                            }"
                            @swiperprogress="onProgress"
                        >
                        
                            <swiper-slide v-for="job in jobs" :key="job.id">
                                <NuxtLink :to="`job/${job.slug}`" class="pa-1 d-block">
                                    <CardJob :job="job"  />
                                </NuxtLink>
                            </swiper-slide>
                        </swiper-container>
                </div>
            </div>
        </VContainer>
    </section>
</template>

<style lang="scss">

    .recent-job {
        @include vwUnit('padding', 50 0 50, 42 0 42);
        background-color: #fff;

        &__header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }
    }
</style>
